import App from './App.vue';
import { createConnectedVehiclesApp } from '@library/AppConfiguration/LibraryOptions';
import { AppOptions } from '@library/AppConfiguration/AppOptions'; 
import { useSessionState } from '@library/Security/Services/SessionStateService';
import { useModals } from '@library/Components/Modal/ModalService';
import { useScrollTop } from './utilities/UseScrollTop';

import './assets/styles/tailwind/index.css';
import './assets/styles/app-styles.scss';

// Routes and navigation
import { routes, navigation } from "./routes";
import { useGlobalComponents } from './global.components';
//import { useAddPresentationRoutes } from './modules/Presentation/Types/AddPresentationRoutes';

//useAddPresentationRoutes( routes );
const configuration = new AppOptions( routes, navigation );
configuration.setStyle( 'theme-default', false );

// Create App and provide any other confgurations
const app = createConnectedVehiclesApp( App, configuration );

app.use( useSessionState() );
app.use( useModals() );
app.use( useScrollTop() );
app.use( useGlobalComponents() );

app.mount( '#app' );
